module.exports = __webpack_public_path__ + "img/purple_wave-03.7ccfce70.png";